

export function subTotal({
  deliveryFee,
  chargeDeliveryFee,
  totalCost: total,
  reservationDeliveryFee,
  cartInsuranceFee = 0
}) {
    const totalCost = total + cartInsuranceFee;
    if (!chargeDeliveryFee && deliveryFee && !reservationDeliveryFee) {
        return totalCost + deliveryFee;
    }
    else if (!chargeDeliveryFee && deliveryFee && reservationDeliveryFee) {
        return totalCost - reservationDeliveryFee + deliveryFee;
    }
    return totalCost;
}
